export function clientDisplayNameFromSlug(clientSlug: string) {
  if (clientSlug === "carrefour-gourmet-ma") {
    return "Carrefour Gourmet";
  }
  if (clientSlug === "atacadao-ma") {
    return "Atacadao";
  }
  return clientSlug
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
